import React from "react";
import { formatAssignmentStatus } from "../../utils/formatAssignmentStatus";
import useStatusColors from "../../hooks/useStatusColors";
import "./WorkloadTimeline.css";

export default function WorkloadTimeline({ items = [], weekLabel }) {
  const { getStatusStyle } = useStatusColors();

  const projects = [
    ...new Set(
      items.flatMap((item) =>
        (item.assignments || []).map((a) => a.projectName),
      ),
    ),
  ];

  const PROJECT_COLORS = [
    "#4F46E5",
    "#0891B2",
    "#059669",
    "#D97706",
    "#DC2626",
    "#7C3AED",
    "#DB2777",
  ];

  const projectColorMap = new Map(
    projects.map((name, i) => [name, PROJECT_COLORS[i % PROJECT_COLORS.length]]),
  );

  return (
    <div className="panel workload-timeline">
      <div className="workload-header">
        <div style={{ fontWeight: 600 }}>Who is working on what this week</div>
        <div className="small-muted">{weekLabel}</div>
      </div>

      <div className="workload-rows">
        {items.map((item) => {
          const assignments = item.assignments || [];

          return (
            <div key={item.userId} className="workload-row">
              <div className="workload-user">
                <div className="workload-user-avatar">
                  {item.firstName?.[0]}
                  {item.lastName?.[0]}
                </div>
                <div>
                  <div className="workload-user-name">
                    {item.firstName} {item.lastName}
                  </div>
                  <div className="workload-user-role">{item.role}</div>
                </div>
              </div>

              <div className="workload-assignments">
                {assignments.length === 0 ? (
                  <span className="workload-free">Available</span>
                ) : (
                  assignments.map((a) => {
                    const statusInfo = formatAssignmentStatus(a.status);
                    const statusStyle = getStatusStyle(a.status, a.slaPercentage);

                    return (
                      <div
                        key={a.id}
                        className="workload-task-chip"
                        style={{
                          backgroundColor: statusStyle.backgroundColor,
                          borderLeft: `3px solid ${statusStyle.borderColor}`,
                        }}
                        title={`${a.stageName} - ${a.projectName} - ${a.status}`}
                      >
                        <span className="workload-task-stage">{a.stageName}</span>
                        <span className="workload-task-project">{a.projectName}</span>
                        <span
                          className="workload-task-status"
                          style={{ color: statusInfo.textColor }}
                        >
                          {statusInfo.icon}
                        </span>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          );
        })}

        {items.length === 0 && (
          <div className="small-muted">No workload data available.</div>
        )}
      </div>

      {projects.length > 0 && (
        <div className="workload-legend">
          {projects.map((name) => (
            <div key={name} className="legend-item">
              <span
                className="legend-dot"
                style={{ background: projectColorMap.get(name) }}
              />
              <span>{name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
